// extracted by mini-css-extract-plugin
export default {"btn":"SimpleButton_btn__TqbON","clickAnimation":"SimpleButton_clickAnimation__1RDGi"};